"use server";

import { createClient } from "@/utils/supabase/server";
import {
  performAddListingToCart,
  type PerformAddListingToCartResult,
} from "@/lib/cart-perform-add";

/**
 * Delivery shell for the add-to-cart write — the decision lives in
 * `lib/cart-perform-add.ts` (hex §1: routes and actions orchestrate, they do
 * not decide).
 *
 * Returns the server's verdict so `CartProvider.addItem` can reconcile the row
 * it rendered optimistically against the real row id and quantity instead of
 * re-reading the whole cart to find out (concurrency-design §9.3).
 *
 * The verdict is a discriminated union INCLUDING refusals, and that is
 * load-bearing for a server action specifically: an exception crossing this
 * boundary is redacted by Next in production ("An error occurred in the
 * Server Components render…"), so a thrown refusal reaches the buyer with no
 * usable text. Refusals must travel as data.
 *
 * @see lib/cart/add-to-cart-rejection.ts — incident 2026-08-09
 */
export async function addToCartAction(
  formData: FormData,
): Promise<PerformAddListingToCartResult> {
  const supabase = await createClient();
  return performAddListingToCart(supabase, {
    listingIdRaw: formData.get("listingId") as string,
    qtyToAdd: parseInt(formData.get("qty") as string, 10) || 1,
    userId: formData.get("userId") as string | null,
    guestId: formData.get("guestId") as string | null,
    roomName: formData.get("roomName") as string | null,
    messageId: formData.get("messageId") as string | null,
  });
}
